<div class="grid gap-2">
  <span [id]="labelId" class="text-sm font-medium text-(--pg-text)">{{ label() }}</span>
  <div class="flex flex-wrap items-center gap-3">
    <mat-button-toggle-group [value]="value()" [disabled]="disabled()" [attr.aria-labelledby]="labelId" (change)="answer($event.value)">
      <mat-button-toggle [value]="true">Yes</mat-button-toggle>
      <mat-button-toggle [value]="false">No</mat-button-toggle>
    </mat-button-toggle-group>
    @if (clearable() && !disabled() && value() !== null) {
      <button mat-button type="button" (click)="clear()">Clear answer</button>
    }
  </div>
</div>
